export const AUTH_REDUCER_KEY = 'auth'
export const CONSECUTIVE_FAILED_LOGINS_SHOW_WARNING = 3
export const CONSECUTIVE_FAILED_LOGINS_SHOW_BLOCKED = 10
